import { last } from 'lodash/fp';

import filterOffers from '../../../utils/filterOffers';
import filterOffersByProductType from '../../../../../utils/filter-offers-by-product-type';
import type { Offer } from '../../../types';
import type { ProductTypeType } from '../../../../../types/product';

type OfferSelectionInput = {
  activeOffers: Offer[] | null | undefined;
  filterProductId: string | undefined;
  filterProductType: ProductTypeType | undefined;
  overrideOffers: Offer[] | undefined;
};

const getOfferToDisplay = ({
  activeOffers,
  filterProductId,
  filterProductType,
  overrideOffers,
}: OfferSelectionInput) => {
  const offers = overrideOffers || activeOffers || [];

  if (filterProductId) return last(filterOffers({ filterProductId, offers }));
  return filterOffersByProductType(filterProductType, offers);
};

export default getOfferToDisplay;
